'use strict';

var core = require('core/login/login');
var formValidation = require('base/components/formValidation');
var createErrorNotification = require('base/components/errorNotification');
var recaptcha = require('core/components/recaptcha');

core.reinit = function reinit() {
    $('body').on('login:reinit', () => { // arrow function used to keep `this`
        this.login();
        this.register();
        this.resetPassword();
    });
}


core.register = function register() {
    $('form.registration').submit(function (e) {
        if ($('#checkout-main').length > 0) {
            return;
        }
        var form = $(this);
        e.preventDefault();
        var url = form.attr('action');
        form.spinner().start();
        $('form.registration').trigger('login:register', e);
        recaptcha.check(e, {
            url: url,
            type: 'post',
            dataType: 'json',
            data: form.serialize(),
            success: function (data) {
                form.spinner().stop();
                if (!data.success) {
                    if (data.showAccountExistsError) {
                        form.find('.account-exists-error').removeClass('d-none');
                        form.one('input', function () {
                            form.find('.account-exists-error').addClass('d-none');
                        });
                    } else {
                        $('form.registration').trigger('login:register:error', data);
                        formValidation(form, data);
                    }
                } else {
                    $('form.registration').trigger('login:register:success', data);
                    location.href = data.redirectUrl;
                }
            },
            error: function (err) {
                if (err.responseJSON.redirectUrl) {
                    window.location.href = err.responseJSON.redirectUrl;
                } else {
                    createErrorNotification($('.error-messaging'), err.responseJSON.errorMessage);
                }

                form.spinner().stop();
            }
        });
        return false;
    });
};

module.exports = core;